<template>
	<c-form ref="form" unit-width="100%">
		<c-form-item :label="false">
			<ul class="filter">
				<li v-for="(item, i) in filterList" :key="item.key" class="flex">
					<c-select v-model="item.field" class="filter-field" :options="filterField" :disable-options="disabledFilterField" search :clear="false" @change="filterFieldHandle($event, item)"></c-select>
					<div class="flex-grow flex-column filter-rule">
						<template v-if="item.type == 'text'">
							<div class="flex">
								<c-select v-model="item.textConfig.logic" class="filter-text-logic" :options="textLogicType" :clear="false"></c-select>
								<c-input v-model="item.text" class="flex-grow" placeholder="请输入"></c-input>
							</div>
						</template>
						<template v-else-if="item.type == 'number'">
							<c-select v-model="item.numberConfig.logic" :key="`number${item.key}`" :options="numberLogicType" :clear="false" @change="dynamicTimeHandle($event, item)"></c-select>
							<div class="flex-center-cross">
								<c-select v-model="item.numberConfig.config[0].sign" class="filter-number-sign" :options="numberSign[0]" :clear="false"></c-select>
								<c-input v-model="item.numberConfig.config[0].data" class="flex-grow filter-number-input" type="number" decimal="6" :range="[-Infinity, item.numberConfig.config[1].data]" :clear="false" placeholder="最小值"></c-input>
								<span style="margin: 0 10px;">-</span>
								<c-select v-model="item.numberConfig.config[1].sign" class="filter-number-sign" :options="numberSign[1]" :clear="false"></c-select>
								<c-input v-model="item.numberConfig.config[1].data" class="flex-grow filter-number-input" type="number" decimal="6" :range="[item.numberConfig.config[0].data, Infinity]" :clear="false" placeholder="最大值"></c-input>
							</div>
						</template>
						<template v-else-if="item.type == 'time'">
							<c-select v-model="item.timeConfig.logic" :key="`time${item.key}`" :options="timeLogicType" :clear="false" @change="dynamicTimeHandle($event, item)"></c-select>
							<c-datetime v-show="item.timeConfig.logic == 'static'" v-model="item.range" range></c-datetime>
							<div v-show="item.timeConfig.logic != 'static'" class="filter-time-quick flex-wrap">
								<div v-for="(quick, j) in dynamicTimeQuick[item.timeConfig.logic]" :key="j" @click="dynamicTimeQuickHandle(quick.value, item)">{{quick.name}}</div>
							</div>
							<template v-for="(config, j) in item.timeConfig.config">
								<div v-if="config" :key="j" class="flex-center-cross">
									<span v-show="item.timeConfig.logic == 'dynamicRange'" class="filter-time-text">{{j == 1 ? '止' : '起'}}</span>
									<c-select
										v-model="config.sign"
										class="flex-grow filter-time-sign"
										:options="dynamicTimeSign"
										:clear="false"
									></c-select>
									<c-input
										v-show="config.sign != '0'"
										v-model="config.data"
										class="flex-grow"
										type="stepper"
										:range="[1, Infinity]"
										step-controls="side"
										:clear="false"
									></c-input>
									<c-select
										v-model="config.unit"
										class="filter-time-unit"
										:options="dynamicTimeUnit"
										:clear="false"
									></c-select>
								</div>
							</template>
						</template>
						<template v-else-if="item.type == 'option'">
							<c-select v-if="item.searchHandle" v-model="item.list" :key="`async-option${item.key}`" :ref="`async-option${item.key}`" async :multiple="{linefeed: true}" @search="item.searchHandle"></c-select>
							<c-select v-else v-model="item.list" :key="`option${item.key}`" search :options="item.options" :multiple="{linefeed: true}"></c-select>
						</template>
						<template v-else-if="item.type == 'rel_object'">
							<c-select v-if="item.searchHandle" v-model="item.list" :key="`object${item.key}`" :ref="`object${item.key}`" async :multiple="{linefeed: true}" @search="item.searchHandle"></c-select>
						</template>
					</div>
					<a class="filter-delete" @click="deleteFilterHandle(item, i)"><i class="tf-trash"></i></a>
				</li>
				<li class="flex-center-cross">
					<c-button v-show="!disabledFilterField.length || disabledFilterField.length < filterField.length" prepend-icon="tf-plus" @click="addFilterHandle">添加筛选条件</c-button>
				</li>
			</ul>
		</c-form-item>
	</c-form>
</template>

<script>
	import dictList from '@/store/dict.js'

	export default {
		data() {
			return {
				filterKey: 0,
				filterField: [],
				filterList: [],
				disabledFilterField: [],

				textLogicType: [{
					name: '包含',
					value: 'like'
				}, {
					name: '不包含',
					value: 'notlike'
				}],

				numberLogicType: [{
					name: '在范围内',
					value: 'in'
				}, {
					name: '不在范围内',
					value: 'out'
				}],
				numberSign: [[{
					name: '大于等于',
					value: '>='
				}, {
					name: '大于',
					value: '>'
				}], [{
					name: '小于等于',
					value: '<='
				}, {
					name: '小于',
					value: '<'
				}]],

				timeLogicType: [{
					name: '手动选择',
					value: 'static'
				}, {
					name: '动态筛选',
					value: 'dynamic'
				}, {
					name: '动态筛选（范围）',
					value: 'dynamicRange'
				}],
				dynamicTimeSign: [{
					name: '过去',
					value: '-1'
				}, {
					name: '当前',
					value: '0'
				}, {
					name: '未来',
					value: '1'
				}],
				dynamicTimeUnit: [{
					name: '时',
					value: 'dynamic_time_hour'
				}, {
					name: '日',
					value: 'dynamic_time_date'
				}, {
					name: '周',
					value: 'dynamic_time_week'
				}, {
					name: '月',
					value: 'dynamic_time_month'
				}, {
					name: '季度',
					value: 'dynamic_time_quarter'
				}, {
					name: '年',
					value: 'dynamic_time_year'
				}],
				dynamicTimeQuick: {
					dynamic: [{
						name: '今天',
						value: '#dynamic_time_date@0#,null'
					}, {
						name: '昨天',
						value: '#dynamic_time_date@-1#,null'
					}, {
						name: '本周',
						value: '#dynamic_time_week@0#,null'
					}, {
						name: '上周',
						value: '#dynamic_time_week@-1#,null'
					}, {
						name: '本月',
						value: '#dynamic_time_month@0#,null'
					}, {
						name: '上月',
						value: '#dynamic_time_month@-1#,null'
					}],
					dynamicRange: [{
						name: '近三天',
						value: '#dynamic_time_date@-2#,#dynamic_time_date@0#'
					}, {
						name: '近七天',
						value: '#dynamic_time_date@-6#,#dynamic_time_date@0#'
					}, {
						name: '近三月',
						value: '#dynamic_time_month@-2#,#dynamic_time_month@0#'
					}, {
						name: '近半年',
						value: '#dynamic_time_month@-5#,#dynamic_time_month@0#'
					}]
				}
			}
		},

		methods: {
			async set(workType, list = []) {
				if (!workType) return;
				this.$refs.form.setEditState(false);
				this.filterField = [];
				this.filterList = [];
				this.disabledFilterField = [];
				
				await this.request({
					url: '/sys_user_view/filter_field_list',
					data: {
						work_type_id: workType
					},
					success: data => {
						this.filterField = data.map(item => {
							return {
								name: item.field_title,
								value: item.id,
								data: item
							}
						});
					}
				});

				let objectField = list.filter(item => {
					let field = this.filterField.find(temp => temp.value == item.field_id);
					return field && field.data.field_type == 9 && field.data.config_json.type == 'rel_object';
				});
				let objectFieldValueData = {};
				if (objectField.length) {
					await this.request({
						url: '/sys_field/relation/translate_filter_condition',
						data: {
							filter_condition: objectField
						},
						success: data => {
							objectField.forEach((item, index) => {
								objectFieldValueData[item.field_id] = data[index].field_value;
							});
						}
					})
				}

				this.filterList = list.map(item => {
					let field = this.filterField.find(temp => temp.value == item.field_id);
					if (!field) return null;

					let key = this.filterKey++;
					let fieldConfig = this.filterFieldHandle(field);
					let extendConfig;
					if (fieldConfig.type == 'text') {
						extendConfig = {
							textConfig: {
								logic: item.query_operator
							}
						}
					} else if (fieldConfig.type == 'number') {
						if (item.field_value.length == 2) {
							extendConfig = {
								numberConfig: {
									logic: 'in',
									config: [{
										sign: '>=',
										data: item.field_value[0] || ''
									}, {
										sign: '<=',
										data: item.field_value[1] || ''
									}]
								}
							}
						} else {
							let logic = item.field_value[0];
							let data = [1, 2].map(index => {
								let temp = item.field_value[index] ? item.field_value[index].match(/^#([><=]{1,2})@([-?\d\.]+)#$/) || [] : [];
								return {
									sign: temp[1] || (index == 2 ? '<=' : '>='),
									data: temp[2] || ''
								}
							});
							extendConfig = {
								numberConfig: {
									logic,
									config: data
								}
							}
						}
					} else if (fieldConfig.type == 'time') {
						extendConfig = {
							timeConfig: {
								logic: item.field_value[0].includes('#') ? item.field_value[1] ? 'dynamicRange' : 'dynamic' : 'static',
								config: item.field_value.map(this.parseDynamicTime)
							}
						}
					} else if (fieldConfig.type == 'option') {
						if (field.data.field_type != 9 && field.data.config_json.dict_config.dictType == 'DBDIC') {
							this.request({
								url: '/system/options',
								data: {
									options_code: field.data.config_json.dict_config.dictName,
									ids: item.field_value
								},
								success: data => {
									if (field.data.config_json.dict_config.dictName == 'SYSUSER' && item.field_value.includes('#curr_login_user_id#')) {
										data.unshift({
											name: '当前登录用户',
											value: '#curr_login_user_id#'
										});
									}
									this.$refs[`async-option${key}`][0].setValueData(data);
								}
							});
						}
					} else if (fieldConfig.type == 'rel_object') {
						setTimeout(() => {
							this.$refs[`object${key}`][0].setValueData(objectFieldValueData[item.field_id] || []);
						}, 50);
					}
					return Object.assign(fieldConfig, {
						key,
						field: item.field_id,
						text: fieldConfig.type == 'text' ? item.field_value : '',
						range: fieldConfig.type == 'time' ? item.field_value.map(item => item || '') : ['', ''],
						list: fieldConfig.type == 'option' ? item.field_value : []
					}, extendConfig)
				}).filter(item => item);
			},

			reset() {
				this.disabledFilterField = [];
				this.filterList = [];
			},

			addFilterHandle() {
				let field = this.filterField.find(item => this.disabledFilterField.findIndex(value => value == item.value) == -1);
				this.filterList.push(Object.assign(this.filterFieldHandle(field), {
					key: this.filterKey++,
					field: field.value
				}));
				this.$refs.form.setEditState(true);
			},

			deleteFilterHandle(item, i) {
				this.filterList.splice(i, 1);
				let index = this.disabledFilterField.findIndex(value => value == item.field);
				if (index != -1) {
					this.disabledFilterField.splice(index, 1);
				}
				this.$refs.form.setEditState(true);
			},

			filterFieldHandle({data: field}, item = {}) {
				this.$set(item, 'type',
					field.field_type == 9
						? field.config_json.type == 'formula'
							? field.config_json.value_type
							: field.config_json.type
						: {
							1: 'text',
							2: 'number',
							3: 'time',
							4: 'option'
						}[field.field_type]
				);
				this.$set(item, 'text', '');
				this.$set(item, 'range', ['', '']);
				this.$set(item, 'list', []);
				this.$set(item, 'textConfig', {
					logic: 'like'
				});
				this.$set(item, 'numberConfig', {
					logic: 'in',
					config: [{
						sign: '>=',
						data: ''
					}, {
						sign: '<=',
						data: ''
					}]
				});
				this.$set(item, 'timeConfig', {
					logic: 'static',
					config: ['', '']
				});

				if (item.type == 'option') {
					this.$set(item, 'searchHandle', false);
					if (field.field_type == 9) {
						this.$set(item, 'options', field.config_json.options);
					} else if (field.config_json.dict_config.dictType == 'PAGEDIC') {
						this.$set(item, 'options', dictList[field.config_json.dict_config.dictName]);
					} else if (field.config_json.dict_config.dictType == 'DBDIC') {
						this.$set(item, 'options', []);
						this.$set(item, 'searchHandle', (keyword, resolve) => {
							this.request({
								url: '/system/options',
								data: {
									options_code: field.config_json.dict_config.dictName,
									keyword
								},
								success: data => {
									if (field.config_json.dict_config.dictName == 'SYSUSER') {
										data.unshift({
											name: '当前登录用户',
											value: '#curr_login_user_id#'
										});
									}
									resolve(data);
								}
							})
						});
					}
				} else if (item.type == 'rel_object') {
					this.$set(item, 'searchHandle', (keyword, resolve) => {
						this.request({
							url: '/sys_field/relation/data_list',
							data: {
								query_type: 0,
								relation_field_id: item.field,
								keyword
							},
							success: data => {
								resolve(data.map(item => {
									return {
										name: item.display_value,
										value: item.id
									}
								}))
							}
						})
					});
				}
				this.$nextTick(() => {
					this.disabledFilterField = this.filterList.map(item => item.field);
				});
				return item;
			},

			parseDynamicTime(data) {
				if (!data) return '';
				data = data.match(/^#([a-z_]+)@([-?\d]+)#$/);
				return !data ? '' : {
					sign: data[2] == '0' ? 0 : data[2] / Math.abs(data[2]),
					data: data[2] == '0' ? 1 : Math.abs(data[2]),
					unit: data[1]
				}
			},

			dynamicTimeHandle({value: logic}, item) {
				this.$set(item, 'range', ['', '']);
				this.$set(item.timeConfig, 'config', [
					logic.includes('dynamic') ? {
						sign: -1,
						data: 1,
						unit: 'dynamic_time_date'
					} : '',
					logic == 'dynamicRange' ? {
						sign: -1,
						data: 1,
						unit: 'dynamic_time_date'
					} : ''
				]);
			},

			dynamicTimeQuickHandle(quick, item) {
				item.timeConfig.config = quick.split(',').map(this.parseDynamicTime);
			},

			get() {
				return this.filterList.map(item => {
					if (item.type == 'number') {
						item.range = [item.numberConfig.logic].concat(item.numberConfig.config.map(config => {
							if (!config.data) return '';
							return `#${config.sign}@${config.data}#`;
						}))
					} else if (item.type == 'time' && item.timeConfig.logic != 'static') {
						item.range = item.timeConfig.config.map(config => {
							if (!config) return '';
							return `#${config.unit}@${config.sign == '0' ? 0 : parseInt(config.sign) * parseInt(config.data)}#`;
						})
					}
					return {
						field_id: item.field,
						query_operator: item.type == 'text' ? item.textConfig.logic : ['option', 'rel_object'].includes(item.type) ? 'in' : 'range',
						field_value: item.type == 'text' ? item.text.trim() : ['option', 'rel_object'].includes(item.type) ? item.list : item.range.map(item => item || null)
					}
				}).filter(item => Array.isArray(item.field_value) ? item.field_value.filter(item => item || item === 0).length : item.field_value);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.filter {
		&-field {
			width: 140px;
			min-width: 140px;
		}

		&-rule {
			gap: 6px;
		}

		&-delete {
			align-self: flex-start;
			padding: 5px;
			margin-top: 7px;
			font-size: 15px;
			color: #f00;

			&:hover {
				border-radius: 4px;
				background: #F5F5F5;
			}
		}

		li {
			gap: 10px;

			&:nth-child(n+2) {
				margin-top: 12px;
			}
		}
	}

	.filter-text {
		&-logic {
			width: 80px;
			min-width: 80px;
			margin-right: 8px;
		}
	}

	.filter-number {
		&-sign {
			width: 95px;
			margin-right: -1px;

			&.z-active, &:hover {
				z-index: 1;
			}
		}

		&-input {
			width: 0;
		}
	}

	.filter-time {
		&-quick {
			gap: 5px;

			div {
				border-radius: 10px;
				padding: 0 10px;
				line-height: 20px;
				font-size: 12px;
				background: #F8F8F8;
				cursor: pointer;

				&:hover {
					color: #fff;
					background: var(--color-main);
				}
			}
		}

		&-text {
			min-width: 30px;
			border: 1px solid var(--unit-border);
			margin-right: -1px;
			line-height: 36px;
			text-align: center;
			background: #fafafa;
		}

		&-sign {
			margin-right: -1px;

			&.z-active, &:hover {
				z-index: 1;
			}
		}

		&-unit {
			min-width: 80px;
			width: 80px;
			margin-left: 8px;
		}
	}
</style>
